/* unplugin-vue-components disabled */import script from "./ProfilePopup.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfilePopup.vue?vue&type=script&setup=true&lang=js"

import "./ProfilePopup.vue?vue&type=style&index=0&id=16d56ca6&lang=scss"

const __exports__ = script;

export default __exports__